/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';

const POSITIONS = {
  [cardProviders.MONAVATE]: {
    x: 115,
    y: 165,
    fontSize: 12,
    fontColor: '#FF5300',
  },
};
export function CVVValue({
  isShowSecretInfo = false,
  isLoadingCVC = false,
  cvc = '',
  onClick = () => {},
  cvcError = null,
}) {
  const { cardProvider } = useUserCardProvider();

  const { x = 135, y = 130, fontSize = 16, fontColor = '#191919' } = POSITIONS[cardProvider] || {};

  return (
    <g>
      {(!isShowSecretInfo || isLoadingCVC || cvcError || !cvc) && (
        <text
          className="cursor-pointer cvv-private-label-custom"
          fill={cvcError ? '#142633' : fontColor}
          fontWeight="500"
          fontSize={fontSize}
          x={x}
          y={y + 2}
          onClick={cvcError ? () => {} : onClick}>
          ***
        </text>
      )}
      {isShowSecretInfo && !isLoadingCVC && (
        <text fill="#191919" fontWeight="500" fontSize={fontSize} x={x} y={y}>
          {cvc}
        </text>
      )}
    </g>
  );
}
CVVValue.propTypes = {
  isShowSecretInfo: PropTypes.bool,
  isLoadingCVC: PropTypes.bool,
  cvc: PropTypes.string,
  onClick: PropTypes.func,
  cvcError: PropTypes.object,
};
export default CVVValue;
